import React from 'react';
import PropTypes from 'prop-types';
import { AtomicText } from './Text';

const footnoteStyle = {
  mobile: {
    font: '700 16px/17px "CentraNo2", sans-serif',
    color: 'black',
    'letter-spacing': '0.28px',
    'line-height': '17px',
    'white-space': 'pre-wrap',
    margin: 0
  },
  tablet: {},
  desktop: {}
};

const Footnote = ({ text, className, element = 'p' }) => (
  <AtomicText
    element={element}
    mobileDesign={footnoteStyle.mobile}
    tabletDesign={footnoteStyle.tablet}
    desktopDesign={footnoteStyle.desktop}
    className={className || 'footnote'}
  >
    {text}
  </AtomicText>
);

Footnote.defaultProps = {
  element: 'p',
  className: undefined
};

Footnote.propTypes = {
  text: PropTypes.string.isRequired,
  element: PropTypes.string,
  className: PropTypes.string
};

export default Footnote;
